import React from 'react';

export const SectionHeader = ({ title, quarter, icon: Icon, subtitle }) => {
  return (
    <div className="section-header" data-testid={`section-header-${title?.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="flex items-center gap-4">
        {quarter && (
          <span className="quarter-badge">
            {quarter}
          </span>
        )}
        {Icon && (
          <div className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center">
            <Icon className="w-6 h-6 text-emerald-400" />
          </div>
        )}
      </div>
      <div>
        <h2 className="text-3xl md:text-5xl">{title}</h2>
        {subtitle && (
          <p className="text-slate-400 text-sm md:text-base mt-1">{subtitle}</p>
        )}
      </div>
    </div>
  );
};

export const PageHeader = ({ title, subtitle, backgroundImage }) => {
  return (
    <div 
      className="relative min-h-[40vh] flex items-end pb-12 pt-32"
      data-testid="page-header"
    >
      {backgroundImage && (
        <>
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/80 to-slate-950/40" />
        </>
      )}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="animate-fade-in-up">
          <h1 
            className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-white uppercase tracking-tighter"
            style={{ fontFamily: 'Barlow Condensed, sans-serif' }}
          >
            {title}
          </h1>
          {subtitle && (
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-2xl">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SectionHeader;
